import * as React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';

export default function UploadTable({ rows, isFailed }) {
  return (
    <TableContainer
      component={Paper}
      sx={{
        maxHeight: '300px',
        overflowY: 'auto',
        borderRadius: '16px',
        border: 'none',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        direction: 'rtl',
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'rgba(243, 244, 246, 0.5)',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#10b981',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: '#059669',
          },
        },
      }}
    >
      <Table stickyHeader aria-label="upload table">
        <TableHead>
          <TableRow
            sx={{
              background: isFailed ? '#ff6f6fff' : 'rgba(59, 130, 246)',
              borderRadius: '16px 16px 0 0',
              '& th': {
                fontWeight: 700,
                color: '#ffffffff',
                py: 2.5,
                px: 2,
                fontSize: '0.95rem',
                borderBottom: 'none',
                position: 'sticky',
                top: 0,
                zIndex: 1,
                background: 'inherit',
              },
            }}
          >
            <TableCell>سریال</TableCell>
            <TableCell>وزن</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rows || []).map((row, index) => (
            <TableRow
              key={row.serial || index}
              sx={{
                backgroundColor:
                  index % 2 === 0
                    ? 'rgba(255, 255, 255, 0.9)'
                    : 'rgba(243, 244, 246, 0.9)',
                transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  backgroundColor: 'rgba(191, 219, 254, 0.7)',
                  boxShadow: '0 6px 20px rgba(59, 130, 246, 0.15)',
                },
                '& td': {
                  color: '#1e293b',
                  borderBottom: 'none',
                  py: '8px', // Reduced padding to fit more rows
                  px: 2,
                  fontSize: '0.9rem',
                  fontWeight: 500,
                },
              }}
            >
              <TableCell>{row.serial}</TableCell>
              <TableCell>{row.weight}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
